import bootstrap from '@/js/bootstrap'

import {createApp} from "vue";

import App from '@/js/component/App.vue'
import * as Sentry from "@sentry/vue"

const run = () => {

    const app = createApp(App);

    Sentry.init({
        app,
        dsn: "https://badd3448e201e251e505c2607b31dee6@o4512165211865088.ingest.de.sentry.io/4512165215141968",
        sendDefaultPii: true
    });

    // Bootstrap
    bootstrap(app);

    app.mount('#app');
};

run();
